import React from "react";
import PropTypes from "prop-types";
import ProjectLink from "notifications/components/project_link";

const NotificationEntryCommentLink = (props) => (
  <ProjectLink {...props} append={`entry/${props.entry.id}/comments`} />
);

export default NotificationEntryCommentLink;
